import {session} from '@netx/core-auth/collections/singleton/session';
import {getCurrentPortalProp} from '@netx/core-cms-next/utils/getCurrentPortalProp';

export const canLoginPublicAccess = () => {
	return (
		getCurrentPortalProp('requireLogin') === false &&
		getCurrentPortalProp('enableSignIn') === true &&
		session.isAuthenticatedAsPublicUser()
	);
};
